<template>
    <div v-if="displayColumn">
        <div v-if="item === 'ship_to'">
            <div v-for="line in itemValue" v-if="itemValue.length > 0">
                {{ line }}
            </div>
        </div>
        <div v-else-if="item === 'pay_invoice_btn'">
            <button class="btn btn-sm btn-success" v-if="itemValue" @click.stop="payInvoice($event)">
                <i class="fa fa-credit-card"></i>
                {{ itemLabel }}
            </button>
        </div>
        <div v-else-if="item === 'sds_btn'">
            <a class="btn btn-sm"
               :class="btn_class"
               :href="itemValue[0]"
               v-if="itemValue">
                <i class="fa fa-file-pdf-o"></i>
                {{ itemLabel }}
            </a>
        </div>
        <div v-else-if="item === 'balance'">
            <span v-if="itemValue > 0">
                ${{ itemValue }}
            </span>
        </div>
        <div v-else-if="item === 'due_date'">
            <div class="label label-success" v-if="data.data.balance === 0">
                PAID
            </div>
            <div class="label label-danger" v-else-if="pastDue(itemValue)">
                {{ itemValue }}
            </div>
            <div class="label label-warning" v-else>
                {{ itemValue }}
            </div>
        </div>
        <div class="container-fluid" v-else-if="item === 'payment_details'">
            <div class="row" v-for="payment in itemValue">
                <div class="col-xs-4">
                    {{ payment.date }}
                </div>
                <div class="col-xs-4">
                    {{ payment.method }}
                </div>
                <div class="col-xs-4 text-right">
                    ${{ payment.amount }}
                </div>
            </div>
        </div>
        <div v-else-if="itemIsGenericBtn">
            <a class="btn btn-sm"
               :class="btn_class"
               target="myLab_report"
               :href="getFileURL(itemValue[0])"
               v-if="itemValue.length === 1 && item !== 'report_btn' && orderType !== 'soil'"
               @click.stop="">
                <i class="fa fa-file-pdf-o"></i>
                {{ itemLabel }}
            </a>
            <div ref="dropdown" class="dropdown" v-else-if="item === 'order_form_btn' && itemValue.length === 1 && orderType === 'soil'">
                <button type="button"
                        class="btn btn-sm dropdown-toggle"
                        :class="btn_class"
                        data-toggle="dropdown"
                        @click.stop="toggleDropDown($event)">
                    <i class="fa fa-file-pdf-o"></i>
                    Soil Forms
                    <span class="caret m-l-5"></span>
                </button>
                <ul class="dropdown-menu">
                    <li @click.stop="closeDropdown">
                        <a :href="getFileURL(itemValue[0])" target="_blank">
                            <i class="fa fa-fw fa-file-pdf-o"></i>
                            {{ itemLabel }}
                        </a>
                    </li>
                    <li @click.stop="closeDropdown">
                        <a :href="labelsURL" target="_blank">
                            <i class="fa fa-fw fa-file-pdf-o"></i>
                            Labels
                        </a>
                    </li>
                </ul>
            </div>
            <div ref="dropdown" class="dropdown" v-else-if="itemValue.length > 1 || item === 'report_btn'">
                <button type="button"
                        class="btn btn-sm dropdown-toggle"
                        :class="btn_class"
                        data-toggle="dropdown"
                        @click.stop="toggleDropDown($event)">
                    <i class="fa fa-file-pdf-o"></i>
                    {{ itemLabel }}
                    <span class="caret m-l-5"></span>
                </button>
                <ul class="dropdown-menu">
                    <li v-for="file in itemValue" @click.stop="closeDropdown">
                        <a target="myLab_report" :href="getFileURL(file)">
                            <i class="fa fa-fw fa-file-pdf-o"></i>
                            PDF Report {{ itemValue.length > 1 ? 'v' + file.number : '' }}
                        </a>
                    </li>
                    <li v-if="onlineSoilReportURL" @click.stop="closeDropdown">
                        <a target="myLab_report" :href="onlineSoilReportURL">
                            <i class="fa fa-fw fa-table"></i>
                            Interactive Report
                        </a>
                    </li>
                    <!-- Don't Allow user to download report in ad-hoc format if report is element (PDF only) -->
                    <li v-if="item === 'report_btn' && !data.details.element" @click.stop="downloadReport">
                        <a href="#">
                            <i class="fa fa-fw fa-download"></i>
                            Download
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="btn btn-sm"
             :class="btn_class"
             v-else-if="item === 'report_btn' && !data.details.complete && showPartialResultsButton"
             @click.stop="showPartialResults">
            <i class="fa fa-table" ></i>
            Results
        </div>
        <div v-else-if="item === 'report_btn'">
            <button class="btn btn-sm btn-success" v-if="data.needsPayment && showBilling" @click.stop="payReport($event)">
                <i class="fa fa-credit-card"></i>
                <span style="font-size:0.75em">Pay Balance</span>
            </button>
            <div class="payment-needed text-center" v-else-if="data.needsPayment">
                Payment Needed
            </div>
        </div>
        <div v-else-if="item === 'billing_summary_btn'"></div>
        <div class="label label-warning" v-else-if="data.type.code === 'report' && item === 'report_nbr' && !data.details.complete">
            IN PROGRESS
        </div>
        <div v-else-if="item === 'tracking_btn'">
            <a class="btn btn-sm btn-pdf" :href="trackingUrl" v-if="trackingUrl" target="_blank">
                <i class="fa fa-truck"></i>
                Track
            </a>
        </div>
        <div v-else-if="item === 'other_report_formats'">
            <div class="dropdown" v-if="Array.isArray(itemValue) && itemValue.length > 0">
                <button type="button"
                        class="btn btn-sm dropdown-toggle btn-primary"
                        data-toggle="dropdown"
                        @click.stop="toggleDropDown($event)">
                    <i class="fa fa-file-pdf-o"></i>
                    {{ itemLabel }}
                    <span class="caret m-l-5"></span>
                </button>
                <ul class="dropdown-menu">
                    <li v-for="format in itemValue" @click.stop="">
                        <a target="myLab_report" href="#????">{{ format.format_number  }} ~ {{ format.common_name }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else>
            {{ itemValue }}
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        props: {
            column: { default: null },
            data: {
                default: {
                    type: {
                        code: null
                    }
                }
            },
            btn_class: { default: 'btn-primary' }
        },

        data: function () {
            return {
                todays_date: null
            }
        },

        computed: {
            ...mapState('documents', [
                'userIsSysAdmin',
                'showBalanceColumn',
                'userAccountRoles'
            ]),

            item () {
                return _.has(this.column,'column') ? this.column.column : null;
            },

            itemValue () {
                return _.has(this.data,'data',this.item) ? this.data.data[this.item] : null;
            },

            trackingUrl () {
                let url = '';
                let courier = _.has(this.data,['data','courier']) ? this.data.data.courier.toLowerCase() : null;
                switch (courier) {
                    case 'ups':
                        url = 'https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=' + this.itemValue;
                        break;
                    case 'fedex':
                        url = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + this.itemValue;
                        break;
                    case 'speedee':
                        url = 'http://packages.speedeedelivery.com/index.php?barcodes=' + this.itemValue;
                        break;
                }
                return url;
            },

            itemLabel () {
                return _.has(this.column,'label') ? this.column.label : null;
            },

            showBilling: function() {
                if (this.userIsSysAdmin) return true;
                const accountRoles = (this.data.account && this.userAccountRoles[this.data.account.account_nbr])
                    ? this.userAccountRoles[this.data.account.account_nbr]
                    : [];
                return accountRoles.indexOf('BILL') !== -1;
            },

            displayColumn () {
                return !((!this.showBalanceColumn && this.item === 'balance') || (!this.showBilling && this.item === 'billing_summary_btn'));
            },

            itemIsGenericBtn () {
                switch (this.item) {
                    case 'order_form_btn':
                    case 'invoice_btn':
                        return true;
                    case 'billing_summary_btn':
                        return this.showBilling;
                    case 'report_btn':
                        if (this.data.account.is_credit_card) {
                            return this.data.details.balanceDue === 0;
                        } else {
                            return this.data.details.complete;
                        }
                    default:
                        return false
                }
            },

            reportType () {
                return _.has(this.data,['details','reportType']) ? this.data.details.reportType.toLowerCase() : null;
            },

            orderType () {
                return _.has(this.data,['details','orderType']) ? this.data.details.orderType.toLowerCase() : null;
            },

            isSoil () {
                return this.reportType === 'soil';
            },

            onlineSoilReportURL () {
                if (this.isSoil && this.data.details.complete && this.item === 'report_btn') {
                    return '/reports/online/' + this.data.details.reportNumber;
                }

                return null;
            },

            showPartialResultsButton () {
                // Partial results are not available for soils or plants
                if (['soil','plant'].includes(this.reportType)) return false;

                return !this.data.account.is_credit_card || this.userIsSysAdmin;
            },

            labelsURL () {
                return '/analysis/' + this.data.id.number + "/sample-labels-by-order";
            },
        },

        methods: {
            ...mapActions('documents', [
                'toggleBalanceColumn'
            ]),

            toggleDropDown: function(event) {
                $(event.currentTarget).next('.dropdown-menu').dropdown('toggle');
            },

            getFileURL (file) {
                return (this.data.account.account_nbr && file.fileID)
                        ? '/documents/' + this.data.account.account_nbr + '/' + file.fileID
                        : null;
            },

            checkBalanceColumn () {
                if (this.data.account.is_credit_card && this.data.data.balance > 0 && this.data.details.complete && this.showBilling) {
                    this.toggleBalanceColumn();
                } else if (this.data.type.code === 'invoice') {
                    this.toggleBalanceColumn();
                }
            },

            showPartialResults () {
                const id = this.data.id.label ? this.data.id.label : this.data.id.number;
                this.$emit('show_partial_results',id);
            },

            payInvoice (event) {
                $(event.target).button('loading');

                const invoice_type = _.has(this.data,['data','invoice_type']) ? this.data.data.invoice_type : null;

                if (invoice_type === 'report') {
                    this.payReportFromInvoiceScreen();
                } else {
                    mwl.submitHiddenForm('/documents/invoices/pay', {
                        invoices: [this.data.details.invoice],
                        price: this.data.details.balance,
                        items: JSON.stringify([{
                            id: this.data.details.invoice,
                            balance: this.data.details.balance,
                            account_nbr: this.data.details.account
                        }])
                    });
                }
            },

            payReport (event) {
                $(event.target).button('loading');
                mwl.submitHiddenForm('/documents/reports/pay', {
                    reports: [this.data.details.reportNumber],
                    price: this.data.details.balanceDue,
                    items: JSON.stringify([{
                        id: this.data.id,
                        account: this.data.account,
                        details: this.data.details
                    }])
                });
            },

            payReportFromInvoiceScreen () {
                mwl.submitHiddenForm('/documents/reports/pay', {
                    reports: [this.data.data.id],
                    price: this.data.details.balance,
                    items: JSON.stringify([{
                        id: this.data.id,
                        account: this.data.account,
                        details: Object.assign(this.data.details, { balanceDue: this.data.details.balance })
                    }])
                });
            },

            pastDue (dueDate) {
                dueDate = moment(dueDate);
                return dueDate.isBefore(this.todays_date);
            },

            downloadReport () {
                this.$emit('download_report', {
                    report_nbr: this.data.data.report_nbr,
                    report_type: this.data.data.report_type,
                    account_nbr: this.data.account.account_nbr
                });

                this.closeDropdown();
            },

            closeDropdown () {
                $(this.$refs.dropdown).removeClass('open');
            }
        },

        mounted () {
            this.todays_date = moment().format('YYYY-MM-DD');

            if (!this.showBalanceColumn && ['balance'].includes(this.item)) {
                this.checkBalanceColumn();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// document-item.vue?9a3c4056